import { getNameVariations } from '../../utils/name';
import type { AppData } from '../../types/app_data';
import { StepCategory } from '../../types/app_data';
import type { Step } from '../types/step';

export const AddDriverSelectNameStep: Step = {
  id: 'adddriverselectname',
  pathname: '/adddriverselectname',
  excludeFromProgressCalculation: true,

  canShow: (appData: AppData) => {
    if (appData.addingNewDriver?.driver) {
      const nameVariations = getNameVariations(appData.addingNewDriver.driver.name);
      if (nameVariations.length > 1) {
        return true;
      }
    }
    return false;
  },
  hasData: () => true,
  hasOwnData: () => true,
  category: () => StepCategory.Drivers,
};
